var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
// css
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Aif&PmsSidebar.scss";
import "@frameworks/shared-library/assets/icons/edel_icons/style.scss";
import "@frameworks/shared-library/assets/scss/variables/fontFamily.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/components/date-picker.scss";
import "@frameworks/shared-library/assets/scss/global/global.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/select.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/upload.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/radio-component.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/Components/genericScheme.scss";
import "@frameworks/salesjourney/stylesheets/components/Features/LeadGenerate/lead.scss";
import "@frameworks/shared-library/stylesheets/components/Offerings/Generic/OfferingsTable.scss";
import "@frameworks/shared-library/stylesheets/components/Aif&PmsSidebar/common.scss";
// components
import TableComponent from "./Components/TableComponent";
import AifPmsDetail from "../../components/AifPmsDetail";
import PurchaseJourney from "../PurchaseJourney";
import LeadGenerationPartner from "../../pages/Features/LeadGeneration/Partner";
import AddClientDetails from "../../pages/client/AddClientDetails";
// helpers
import aifPmsDi from "@mainDi/features/AIF-PMS/servicelocator";
import { accountDetails } from "@mainDi/salesDi";
import { purchaseController } from "../../controller";
// types
import { ELocalStorageKeys } from "@domains/salesFeatures/Common/entities/ELocalStorageKeys";
import { ILoginTypeEnum } from "@domains/salesFeatures/Login/entities/iLogin";
import { FieldNames } from "../../constants/constant";
function BookmarkTable(_a) {
    //
    var _this = this;
    var _b, _c;
    var subCategoryId = _a.subCategoryId, header = _a.header, viewAll = _a.viewAll, viewAllClick = _a.viewAllClick, showDataPerPage = _a.showDataPerPage, setTotalDataRecord = _a.setTotalDataRecord, viewAllClickPath = _a.viewAllClickPath, isAll = _a.isAll, searchText = _a.searchText;
    var _d = __read(useState(false), 2), loader = _d[0], setLoader = _d[1];
    var _e = __read(useState(false), 2), addClientVisible = _e[0], setAddClientVisible = _e[1];
    var _f = __read(useState(null), 2), clientDetails = _f[0], setCientDetails = _f[1];
    var _g = __read(useState({
        page: 1,
        category_code: subCategoryId,
        pageSize: showDataPerPage || 1,
        LoginCode: "",
        orderBy: "returns_expectations",
        orderByDesc: true,
    }), 2), requestPayload = _g[0], setRequestPayload = _g[1];
    var _h = __read(useState([]), 2), watchlistData = _h[0], setWatchlistData = _h[1];
    var _j = __read(useState(1), 2), totalPages = _j[0], setTotalPages = _j[1];
    var _k = __read(useState(0), 2), totalRecord = _k[0], setTotalRecord = _k[1];
    var _l = __read(useState(false), 2), detailVisible = _l[0], setDetailVisible = _l[1];
    var _m = __read(useState(false), 2), purchaseVisible = _m[0], setPurchaseVisible = _m[1];
    var _o = __read(useState(false), 2), partnerLeadVisible = _o[0], setPartnerLeadVisible = _o[1];
    var _p = __read(useState(1), 2), fundTotalPages = _p[0], setFundTotalPages = _p[1];
    var _q = __read(React.useState({
        isOpen: false,
        error: undefined,
    }), 2), error = _q[0], setError = _q[1];
    var _r = purchaseController(), onClickContinue = _r.onClickContinue, clearPurchaseValues = _r.clearPurchaseValues, loading = _r.loading, errorMessage = _r.errorMessage, errorVisible = _r.errorVisible;
    var partnerCategory = localStorage.getItem(ELocalStorageKeys.LoginType);
    useEffect(function () {
        var getBookMarkData = function () { return __awaiter(_this, void 0, void 0, function () {
            var loginCode, updateObject;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, accountDetails.getUserLoginCode()];
                    case 1:
                        loginCode = _a.sent();
                        setLoader(true);
                        setError({
                            isOpen: false,
                            error: undefined,
                        });
                        updateObject = __assign(__assign({}, requestPayload), { category_code: subCategoryId, searchText: searchText });
                        aifPmsDi.aifPms
                            .bookmarkWatchList(__assign(__assign({}, updateObject), { LoginCode: loginCode }))
                            .then(function (res) {
                            if (res && res.data) {
                                var _data_1 = res.data;
                                setTotalPages(res.totalpages);
                                setTotalRecord(res.totalitems);
                                if (setTotalDataRecord) {
                                    setTotalDataRecord(res.totalitems);
                                }
                                if (_data_1 && Array.isArray(_data_1)) {
                                    if (requestPayload.page > 1) {
                                        setWatchlistData(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), __read(_data_1), false); });
                                    }
                                    else {
                                        setWatchlistData(__spreadArray([], __read(_data_1), false));
                                    }
                                }
                                else {
                                    setWatchlistData([]);
                                }
                            }
                            else {
                                setWatchlistData([]);
                            }
                            setLoader(false);
                        })
                            .catch(function (error) {
                            setError({
                                isOpen: true,
                                error: error,
                            });
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        getBookMarkData();
    }, [requestPayload, viewAllClickPath, searchText, header]);
    var handleSearchFunds = function (value) {
        if (value) {
            var localFilterData = __assign(__assign({}, requestPayload), { searchText: value, page: 1 });
            setLoader(true);
            setError({
                isOpen: false,
                error: undefined,
            });
            aifPmsDi.aifPms
                .bookmarkWatchList(localFilterData)
                .then(function (res) {
                if (res && res.data) {
                    var _data_2 = res.data;
                    setTotalPages(res.totalpages);
                    setTotalRecord(res.totalitems);
                    if (setTotalDataRecord) {
                        setTotalDataRecord(res.totalitems);
                    }
                    if (_data_2 && Array.isArray(_data_2)) {
                        if (requestPayload.page > 1) {
                            setWatchlistData(function (prev) { return __spreadArray(__spreadArray([], __read(prev), false), __read(_data_2), false); });
                        }
                        else {
                            setWatchlistData(__spreadArray([], __read(_data_2), false));
                        }
                    }
                    else {
                        setWatchlistData([]);
                    }
                }
                else {
                    setWatchlistData([]);
                }
                setLoader(false);
            })
                .catch(function (error) {
                setError({
                    isOpen: true,
                    error: error,
                });
            });
        }
    };
    useEffect(function () {
        if (!isAll) {
            aifPmsDi.aifPms
                .getFilterDetails({
                category_code: String(subCategoryId),
                fieldName: FieldNames.FUND_NAME,
                orderByDesc: true,
                page: 1,
                pageSize: 10,
            })
                .then(function (res) {
                setFundTotalPages(res === null || res === void 0 ? void 0 : res.totalpages);
            });
        }
    }, [subCategoryId]);
    useEffect(function () {
        aifPmsDi.aifPms.updateSubCategoryId(subCategoryId);
    }, [subCategoryId]);
    return (React.createElement("div", { className: "aif-pms mt-4" },
        React.createElement(TableComponent, { aifPmsListData: watchlistData, setRequestPayload: setRequestPayload, setTotalDataRecord: setTotalDataRecord, requestPayload: requestPayload, totalPages: totalPages, subCategoryId: subCategoryId, aifPmsLoader: loader, aifPmsTableLoader: loader, header: header, totalRecord: totalRecord, error: error, setWatchlistData: setWatchlistData, rowOnClick: function (item) {
                setDetailVisible(true);
                setCientDetails(item);
                aifPmsDi.aifPms.updateWatchListData(item);
            }, onClickPlaceOrder: function (item) {
                if (partnerCategory == ILoginTypeEnum.PARTNER) {
                    setPartnerLeadVisible(true);
                }
                else {
                    clearPurchaseValues();
                    setPurchaseVisible(true);
                }
                aifPmsDi.aifPms.updateWatchListData(item);
            }, viewAll: viewAll, viewAllClick: viewAllClick, showDataPerPage: showDataPerPage, viewAllClickPath: viewAllClickPath, handleCallbackSearchFunds: handleSearchFunds, isAll: isAll, fundTotalPages: fundTotalPages, setFundTotalPages: setFundTotalPages }),
        React.createElement(AifPmsDetail, { subCategoryId: subCategoryId, visible: detailVisible, item: {
                schemeId: (_b = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.schemeId) !== null && _b !== void 0 ? _b : 0,
                fundName: (_c = clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.display_name) !== null && _c !== void 0 ? _c : "",
            }, setVisible: setDetailVisible, onClickClose: function () {
                setDetailVisible(false);
                clearPurchaseValues();
            }, onClickPlaceOrder: function () {
                if (partnerCategory == ILoginTypeEnum.PARTNER) {
                    setPartnerLeadVisible(true);
                }
                else {
                    setDetailVisible(false);
                    clearPurchaseValues();
                    setPurchaseVisible(true);
                    aifPmsDi.aifPms.updateWatchListData({
                        display_name: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.display_name,
                        isfocused: clientDetails.isfocused,
                        inception_date: clientDetails.inception_date,
                        tenure: clientDetails.tenure,
                        returns_expectations: clientDetails.returns_expectations,
                        benchmark: clientDetails.benchmark,
                        schemeId: clientDetails === null || clientDetails === void 0 ? void 0 : clientDetails.schemeId,
                        min_investment: clientDetails.min_investment,
                        min_investment_in_cr: clientDetails.min_investment_in_cr,
                    });
                }
            }, isPartner: partnerCategory == ILoginTypeEnum.PARTNER }),
        partnerLeadVisible && (React.createElement(LeadGenerationPartner, { visible: partnerLeadVisible, setVisible: setPartnerLeadVisible })),
        React.createElement(PurchaseJourney, { subCategoryId: subCategoryId, loading: loading, visible: purchaseVisible, setVisible: setPurchaseVisible, onClickContinue: onClickContinue, onClickCancel: function () {
                setPurchaseVisible(false);
                clearPurchaseValues();
            }, onSelectClient: function (item) {
                if (item.ispansearch == "true") {
                    setPurchaseVisible(false);
                    setAddClientVisible(true);
                }
            }, errorMessage: errorMessage, errorVisible: errorVisible }),
        React.createElement(AddClientDetails, { visible: addClientVisible, setVisible: setAddClientVisible, onClickVerify: function (response) {
                if (response.data.length > 0) {
                    setAddClientVisible(false);
                    setPurchaseVisible(true);
                }
            } })));
}
export default BookmarkTable;
